<template>
  <div id="intro">
    <div>
      <p>There is no “done” in digital transformation. Whether you're just starting the journey or well on your way to optimized workflows, improvement is an always-on initiative.</p>
      <p>This interactive tool is designed to help you recognize opportunities for continued evolution across your organization and identify solutions to meet your unique needs and requirements.</p>
      <pager
        @click="stepping"
        :currentPage="currentPage"
        prevText="Prev"
        nextText="Let's get started"
      />
    </div>
    <div>
      <img src="../assets/page-1/solution-configurator-page-1.svg">
    </div>

  </div>
</template>

<script>
import Pager from '../components/Pager.vue'

export default {
  name: 'Intro',
  components: { Pager },
  props: ['currentPage'],
  methods: {
    stepping() {
      this.$emit('stepped', true);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @media (min-width: 576px) {
    #intro {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 30px;
    }
  }
</style>
